// Quelle: /opt/lilasprojekte/frontend/src/hooks/useTitel.ts (Stand 2026-09-29)
// Geändert: BASIS "Handschrift" (Titel „… · Handschrift“).
import { useEffect } from "react";

const BASIS = "Handschrift";

/**
 * Setzt den Dokumenttitel und stellt ihn beim Verlassen zurück.
 *
 * Warum überhaupt: mit mehreren offenen Reitern ist der Titel die einzige
 * Stelle, an der man sieht, welcher davon welchen Beleg zeigt — und ein
 * Einzelseiten-Programm ändert ihn von sich aus nie.
 */
export function useTitel(titel?: string): void {
  useEffect(() => {
    const vorher = document.title;
    document.title = titel ? `${titel} · ${BASIS}` : BASIS;
    return () => {
      document.title = vorher;
    };
  }, [titel]);
}
